import { withAugmentedPalette } from "./brandingTheme";

export const BRANDING_SESSION_KEYS = {
  secondary: "_bc",
  primary: "_pc",
  paper: "_fp",
  error: "_ec",
  warning: "_wc",
  info: "_ic",
  success: "_sc",
  logo: "_l",
};

const readStoredColor = (key) =>
  localStorage.getItem(key) || sessionStorage.getItem(key);

export const getStoredBrandingColors = () => ({
  primary: readStoredColor(BRANDING_SESSION_KEYS.primary),
  secondary: readStoredColor(BRANDING_SESSION_KEYS.secondary),
  paper: readStoredColor(BRANDING_SESSION_KEYS.paper),
  error: readStoredColor(BRANDING_SESSION_KEYS.error),
  warning: readStoredColor(BRANDING_SESSION_KEYS.warning),
  info: readStoredColor(BRANDING_SESSION_KEYS.info),
  success: readStoredColor(BRANDING_SESSION_KEYS.success),
  logo: readStoredColor(BRANDING_SESSION_KEYS.logo),
});

const persistColor = (key, value) => {
  if (!value) {
    return;
  }
  localStorage.setItem(key, value);
  sessionStorage.setItem(key, value);
};

export const saveBrandingColorsToSession = (palette) => {
  persistColor(BRANDING_SESSION_KEYS.secondary, palette?.secondary?.main);
  persistColor(BRANDING_SESSION_KEYS.primary, palette?.primary?.main);
  persistColor(BRANDING_SESSION_KEYS.paper, palette?.background?.paper);
  persistColor(BRANDING_SESSION_KEYS.error, palette?.error?.main);
  persistColor(BRANDING_SESSION_KEYS.warning, palette?.warning?.main);
  persistColor(BRANDING_SESSION_KEYS.info, palette?.info?.main);
  persistColor(BRANDING_SESSION_KEYS.success, palette?.success?.main);
};

export const saveLogoutLogoToSession = (base64Logo) => {
  if (!base64Logo) {
    return;
  }
  localStorage.setItem(BRANDING_SESSION_KEYS.logo, base64Logo);
  sessionStorage.setItem(BRANDING_SESSION_KEYS.logo, base64Logo);
};

const mergeSeverityColor = (paletteEntry, storedColor) =>
  storedColor ? { ...paletteEntry, main: storedColor } : paletteEntry;

export const mergeBrandingIntoTheme = (theme) => {
  const { primary, secondary, paper, error, warning, info, success } =
    getStoredBrandingColors();

  if (
    !primary &&
    !secondary &&
    !paper &&
    !error &&
    !warning &&
    !info &&
    !success
  ) {
    return theme;
  }

  return {
    ...theme,
    palette: {
      ...theme.palette,
      primary: {
        ...theme.palette.primary,
        ...(primary ? { main: primary } : {}),
      },
      secondary: {
        ...theme.palette.secondary,
        ...(secondary ? { main: secondary } : {}),
      },
      background: {
        ...theme.palette.background,
        ...(paper ? { paper } : {}),
      },
      error: mergeSeverityColor(theme.palette.error, error),
      warning: mergeSeverityColor(theme.palette.warning, warning),
      info: mergeSeverityColor(theme.palette.info, info),
      success: mergeSeverityColor(theme.palette.success, success),
    },
  };
};

const brandingMatchesTheme = (theme, augmented) =>
  augmented.palette.primary.main === theme.palette.primary.main &&
  augmented.palette.secondary.main === theme.palette.secondary.main &&
  augmented.palette.background.paper === theme.palette.background.paper &&
  augmented.palette.error.main === theme.palette.error.main &&
  augmented.palette.warning.main === theme.palette.warning.main &&
  augmented.palette.info.main === theme.palette.info.main &&
  augmented.palette.success.main === theme.palette.success.main;

export const applyBrandingFromSession = (theme, setTheme) => {
  const augmented = withAugmentedPalette(mergeBrandingIntoTheme(theme));
  if (brandingMatchesTheme(theme, augmented)) {
    return;
  }
  setTheme(augmented);
};
